(() => {
 const init = () => {
  const header = document.querySelector('[data-ez-sticky-header]');
  if (!header || header.dataset.ezStickyReady) return;
  header.dataset.ezStickyReady = 'true';
  const main = header.querySelector('.ez-header-main');
  main?.classList.remove('ez-header-main--fixed');
  const section = header.parentElement;
  const promo = header.querySelector('.ez-secondary');
  const promoHeight = promo?.getBoundingClientRect().height || 0;
  const reserveHeight = () => {
   const nav = header.querySelector('.ez-category-nav');
   const styles = getComputedStyle(header);
   const height = (main?.parentElement.offsetHeight || 0) + (nav?.offsetHeight || 0) + promoHeight + parseFloat(styles.borderTopWidth || 0) + parseFloat(styles.borderBottomWidth || 0);
   section.style.setProperty('--ez-header-reserved-height', `${height}px`);
  };
  const update = () => {
   const inspecting = window.Shopify?.inspectMode;
   if (inspecting || window.scrollY < 20) header.classList.remove('ez-header--scrolled');
   else if (window.scrollY > 80) header.classList.add('ez-header--scrolled');
  };
  window.addEventListener('scroll', update, {passive:true});
  window.addEventListener('pageshow', update);
  window.addEventListener('resize', reserveHeight);
  document.fonts?.ready.then(reserveHeight);
  reserveHeight();
  update();
 };
 init();
 document.addEventListener('shopify:section:load', init);
})();
